import { useEffect, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'

import { COMMON_AVAILABLE_HOTKEYS } from '../../common/constants'
import { useRowHighlight } from '../../common/hooks'

import { updateDishIngredientsDrawerHotkeys } from '../redux/actions'

const useDishIngredientsDrawerHotkeyHighlights = () => {
  const [isNavigationEnabled, setNavigationEnabled] = useState(false)

  const { initHighlight } = useRowHighlight({
    tableSelector: '.dish-drawer-table .ant-table-container table',
    rowsSelector:
      '.dish-drawer-table .ant-table-container table tbody > tr:not(.ant-table-measure-row)',
    scrollContainerSelector: '.dish-drawer-table .ant-table-container',
    areHotkeysDisabled: !isNavigationEnabled,
    isCellSelectionDisabled: true,
    isRowSelectionDisabled: !isNavigationEnabled,
    updateHotkeysAction: updateDishIngredientsDrawerHotkeys,
  })

  useEffect(() => {
    setTimeout(initHighlight, 0)
  }, [initHighlight])

  useHotkeys(
    COMMON_AVAILABLE_HOTKEYS.DOWN.hotkey,
    () => {
      setNavigationEnabled(true)
      const [scrollContainer] = document.querySelectorAll(
        '.dishes-table .ant-table-body',
      )
      if (scrollContainer) {
        scrollContainer.scrollIntoView()
      }
    },
    {
      enabled: !isNavigationEnabled,
    },
    [isNavigationEnabled],
  )
}

export default useDishIngredientsDrawerHotkeyHighlights
